import { User } from '@/types/user';
import { api } from './client';
import { organisationApi } from './organisation.api';
import { AppRole } from '@/types/role';

export const userApi = {
  createAccount: async (email: string, firstName: string, lastName: string, create_hubspot: boolean = false): Promise<User> => {
    const { data } = await api.post(`/api/v1/accounts`, { email, first_name: firstName, last_name: lastName, create_hubspot });
    return data;
  },

  getUser: async (): Promise<User> => {
    const { data } = await api.get("/api/v1/accounts");
    return data;
  },

  register: async (email: string, password: string, first_name: string, last_name: string, phone_number: string): Promise<{ token: string, user: User }> => {
    const { data } = await api.post("/users", { email, password, first_name, last_name, phone_number }, { headers: { 'Content-Type': 'multipart/form-data' } });
    return data;
  },

  contactYuzu: async (organisationId: string, message: string) => {
    const { data } = await api.post(`/companies/${organisationId}/contact-form`, { message });
    return data;
  },
  
  updateProfilePicture: async (newImageId: string) => {
    const { data } = await api.put("/users/me/image", { image_id: newImageId });
    return data;
  },

  updatePassword: async (oldPassword: string, newPassword: string) => {
    const { data } = await api.put("/users/me/password", {
      previous_password: oldPassword,
      new_password: newPassword,
    });
    return data;
  },

  role: async (organisationId: string): Promise<AppRole[]> => {
    const { data } = await api.get(`/api/v1/roles/app`, { params: { organization_id: organisationId } });
    return data;
  }
}